export default __webpack_public_path__ + "static/media/warning-triangle-fill.d6455068.svg";